import { Tag } from './Tag';

export type FilterState = {
  view: 'all' | 'upcoming' | 'past';
  tag: string | null;
  search: string;
};

export function Sidebar({
  state,
  setState,
  counts,
  tags,
}: {
  state: FilterState;
  setState: (next: FilterState) => void;
  counts: { all: number; upcoming: number; past: number };
  tags: string[];
}) {
  return (
    <aside className="hidden lg:flex flex-col w-60 shrink-0 sticky top-[68px] self-start max-h-[calc(100vh-72px)] overflow-y-auto pr-2">
      <p className="nav-section-label !mt-0">Browse</p>
      <NavRow
        label="All workshops"
        count={counts.all}
        active={state.view === 'all'}
        onClick={() => setState({ ...state, view: 'all' })}
      />
      <NavRow
        label="Upcoming"
        count={counts.upcoming}
        active={state.view === 'upcoming'}
        onClick={() => setState({ ...state, view: 'upcoming' })}
      />
      <NavRow
        label="Past"
        count={counts.past}
        active={state.view === 'past'}
        onClick={() => setState({ ...state, view: 'past' })}
      />

      <p className="nav-section-label">Topics</p>
      <div className="flex flex-wrap gap-1.5 px-3">
        {tags.length === 0 ? (
          <p className="text-xs text-ink-subtle">No topics yet</p>
        ) : (
          tags.map((tag) => (
            <Tag
              key={tag}
              active={state.tag === tag}
              onClick={() => setState({ ...state, tag: state.tag === tag ? null : tag })}
            >
              {tag}
            </Tag>
          ))
        )}
      </div>
    </aside>
  );
}

function NavRow({
  label,
  count,
  active,
  onClick,
}: {
  label: string;
  count: number;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button type="button" onClick={onClick} className={`nav-item ${active ? 'nav-item-active' : ''}`}>
      <span>{label}</span>
      <span
        className={`text-xs tabular-nums ${active ? 'text-white/70' : 'text-ink-subtle'}`}
      >
        {count}
      </span>
    </button>
  );
}
